import { useState } from "react";
import TopNav from "../home/components/TopNav";
import Sidebar, { MenuId } from "./components/Sidebar";
import ApiMarket from "./components/ApiMarket";
import ApiKey from "./components/ApiKey";
import ApiBenefits from "./components/ApiBenefits";
import ApiUsage from "./components/ApiUsage";
import DataMarketPage from "./components/DataMarketPage";
import DataBenefitsPage from "./components/DataBenefitsPage";

export default function ApiPlatformPage() {
  const [activeMenu, setActiveMenu] = useState<MenuId>("api-market");

  const renderContent = () => {
    switch (activeMenu) {
      case "api-market":
        return <ApiMarket />;
      case "api-key":
        return <ApiKey />;
      case "api-benefits":
        return <ApiBenefits />;
      case "api-usage":
        return <ApiUsage />;
      case "data-market":
        return <DataMarketPage />;
      case "data-benefits":
        return <DataBenefitsPage />;
      default:
        return <ApiMarket />;
    }
  };

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Noto Sans SC', sans-serif" }}>
      <TopNav />
      
      <div className="pt-[3.5rem] flex" style={{ height: 'calc(100vh - 3.5rem)' }}>
        <Sidebar activeMenu={activeMenu} onMenuChange={setActiveMenu} />
        <main className="flex-1 bg-[#f8f9fb] overflow-auto ml-2">
          {renderContent()}
        </main>
      </div>
    </div>
  );
}